import {
  FormLabel, IconButton, Typography, Toolbar,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { FastField } from 'formik';
import type { FastFieldProps } from 'formik';

const useStyles = makeStyles()((theme) => ({
  formLabel: {
    '& + div': {
      marginTop: theme.spacing(1),
      minHeight: theme.spacing(3),
    },
  },
  toolbar: {
    justifyContent: 'flex-end',
  },
  margin: {
    marginRight: theme.spacing(1),
  },
  displayMaximum: {
    minWidth: 25,
  },
}));

interface IncrementProps {
  readonly label?: string;
  readonly name: string;
  readonly min?: number;
  readonly max: number;
  readonly onChange?: (increment: number) => void;
  readonly displayMaximum?: boolean;
}

export const Increment: React.FC<IncrementProps> = ({
  label, name, min = 1, max,
  displayMaximum = false,
  onChange,
}) => {
  const { classes, cx } = useStyles();

  return (
    <FastField
      name={name}
    >
      {({ form, field, meta }: FastFieldProps<number>) => (
        <>
          {Boolean(label) && (
            <FormLabel
              className={classes.formLabel}
              error={Boolean(meta?.error)}
            >
              {label}
            </FormLabel>
          )}

          <Toolbar
            className={classes.toolbar}
            disableGutters
          >
            <IconButton
              color="info"
              className={classes.margin}
              edge="start"
              size="xsmall"
              disabled={field.value <= min || form.isSubmitting}
              onClick={() => {
                void form.setFieldValue(name, field.value - 1);

                if (onChange) {
                  onChange(-1);
                }
              }}
            >
              <RemoveIcon />
            </IconButton>

            <Typography
              variant="body1"
              color="textSecondary"
              className={cx(classes.margin, displayMaximum && classes.displayMaximum)}
            >
              {field.value}

              {Boolean(displayMaximum) && (
                <>
                  /
                  {max}
                </>
              )}
            </Typography>

            <IconButton
              color="info"
              edge="end"
              size="xsmall"
              disabled={field.value >= max || form.isSubmitting}
              onClick={() => {
                void form.setFieldValue(name, field.value + 1);

                if (onChange) {
                  onChange(1);
                }
              }}
            >
              <AddIcon />
            </IconButton>
          </Toolbar>

          <input
            id={name}
            name={name}
            type="hidden"
          />
        </>
      )}
    </FastField>
  );
};
